import { PublicKey } from '@solana/web3.js';
import {
  ASSOCIATED_TOKEN_PROGRAM_ID,
  DEVNET_USDC_MINT,
  TOKEN_PROGRAM_ID,
} from '../constants/programs.js';

/**
 * Derive the user's classic SPL Associated Token Account for an outcome or claim-right token.
 *
 * Seeds: [user, TOKEN_PROGRAM_ID, outcomeMint] via ASSOCIATED_TOKEN_PROGRAM_ID.
 * Current outcome and claim-right mints both belong to the classic SPL Token program.
 *
 * @param user - User wallet public key
 * @param outcomeMint - Outcome token mint public key
 * @returns ATA public key
 */
export function deriveUserOutcomeAta(user: PublicKey, outcomeMint: PublicKey): PublicKey {
  const [ata] = PublicKey.findProgramAddressSync(
    [user.toBuffer(), TOKEN_PROGRAM_ID.toBuffer(), outcomeMint.toBuffer()],
    ASSOCIATED_TOKEN_PROGRAM_ID,
  );
  return ata;
}

/**
 * Derive the SPL Token Associated Token Account for USDC.
 *
 * Seeds: [owner, TOKEN_PROGRAM_ID, usdMint] via ASSOCIATED_TOKEN_PROGRAM_ID.
 * USDC uses the legacy SPL Token program.
 *
 * @param owner - Owner wallet public key
 * @param usdMint - USDC mint address (defaults to devnet USDC)
 * @returns ATA public key
 */
export function deriveUsdcAta(owner: PublicKey, usdMint: PublicKey = DEVNET_USDC_MINT): PublicKey {
  const [ata] = PublicKey.findProgramAddressSync(
    [owner.toBuffer(), TOKEN_PROGRAM_ID.toBuffer(), usdMint.toBuffer()],
    ASSOCIATED_TOKEN_PROGRAM_ID,
  );
  return ata;
}
